import { auth } from "../components/Auth";
import { getFirestore, doc, getDoc, collection, setDoc } from 'firebase/firestore';
import { firebaseConfig } from "../components/constants";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, isSupported } from "firebase/analytics";
import { UpdateClickData } from "../components/types";


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);


export async function logMe(eventName:string, eventParams:any = {}){
  if (!window.location.hostname.includes("localhost") && !window.location.hostname.includes("127.0.0.1")) {
    if ((await isSupported()) === false) {
      return;
    }
    const analyticsObject = getAnalytics(app);
    logEvent(analyticsObject, eventName, eventParams);
  }
}
export async function getRemainingRequests(): Promise<number> {
  try {
    // Get the currently signed-in user
    const user = auth.currentUser;

    if (!user) {
      throw new Error('User not signed in');
    }

    // Get the user's email
    const userEmail = user.email;

    if (!userEmail) {
      throw new Error('User email not found');
    }

    
    // Get the user's document from Firestore
    const userDocRef = doc(collection(db, 'users'), userEmail);
    const userDoc = await getDoc(userDocRef);


    if (!userDoc.exists()) {
      return 5;
    }

    const userData = userDoc.data();

    if (!userData || typeof userData.requestsLeft !== 'number') {
      throw new Error('Invalid user data');
    }

    // If user is subscribed and userData.lastRequestDate is yesterday, return 10
    if (userData.type === 'premium') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayTimestamp = today.getTime();
      if (userData.lastRequestDate < todayTimestamp) {
        return 10;
      }
    }
    return userData.requestsLeft;
  } catch (error) {
    return 0;
  }
}

/*
export async function checkUserSubscriptionStatusFromDB(email:string){
  const userDocRef = doc(collection(db, 'users'), email);
  const userDoc = await getDoc(userDocRef);
  const userData = userDoc.data();
  // If field type is premium, user is subscribed
  if(userData?.type === "premium"){
    return true;
  }
  return false;
}*/


export async function checkUserSubscriptionStatusFromDB(email: string) {
  // If not found in the "users" collection, check the "stripe" collection
  const stripeDocRef = doc(collection(db, 'stripe'), email);
  const stripeDoc = await getDoc(stripeDocRef);
  console.log("Checking")
  // If user is found in the "stripe" collection, return true
  if (stripeDoc.exists()) {
    return true;
  }
  
  // Check the "users" collection
  const userDocRef = doc(collection(db, 'users'), email);
  const userDoc = await getDoc(userDocRef);
  const userData = userDoc.data();

  // If user is not found in the "stripe" collection,
  // check the "users" collection and if a premium subscription exists, return true
  if (userData?.type === "premium") {
    return true;
  }

  

  // If not found in either collection, return false
  return false;
}



export async function updateClickDataToFirestore(userData: UpdateClickData) {
  const updateClickDocRef = doc(collection(db, 'updateClick'), userData.userEmail || "NOEMAIL");

  try {
    // Set the document data in the "updateClick" collection
    await setDoc(updateClickDocRef, userData);

    
  } catch (error) {
    
    // Handle the error as needed
  }
}